import { RootState } from '@client/redux';

export const selectCard = (state: RootState) => {
  return state.card;
};
